import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { useI18n } from "@/i18n";

export function LegalNotice({ withLink = true }) {
  const { t } = useI18n();
  const points = ["legal.p1", "legal.p2", "legal.p3", "legal.p4"];
  return (
    <section className="bg-[#2D231F] text-white" data-testid="legal-notice">
      <div className="max-w-5xl mx-auto px-5 sm:px-8 py-16">
        <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.15em] text-[#E69625] mb-4">
          <ShieldCheck className="w-4 h-4" /> {t("legal.badge")}
        </span>
        <h2 className="font-display text-2xl sm:text-3xl font-black tracking-tight mb-8">{t("legal.title")}</h2>
        <ul className="space-y-4">
          {points.map((k) => (
            <li key={k} className="flex items-start gap-3">
              <span className="mt-1.5 w-2 h-2 rounded-full bg-[#E69625] shrink-0" />
              <span className="text-stone-200 leading-relaxed">{t(k)}</span>
            </li>
          ))}
        </ul>
        {withLink && (
          <Link to="/legal" data-testid="legal-readmore" className="inline-block mt-8 text-[#E69625] font-semibold hover:underline">
            {t("legal.pageTitle")} →
          </Link>
        )}
      </div>
    </section>
  );
}